import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import useUpdateApplication from 'features/application/hooks/useUpdateApplication';
import AddressCollection from 'features/application/screens/AddressCollection/AddressCollection';
import useReactivationPrefillData from 'features/reactivation/hooks/useReactivationPrefillData';
import React from 'react';

const AddressCollectionWrapper = () => {
  const {
    prefillData,
    prefillDataFetching,
    prefillDataError,
    refetch: refetchPrefillData,
    reactivationApplicationId,
  } = useReactivationPrefillData();

  const {
    updateApplication,
    updateApplicationResult,
    isUpdateApplicationLoading,
    isUpdateApplicationSuccess,
  } = useUpdateApplication({
    applicationId: reactivationApplicationId,
    sourceName: SourceName.REACTIVATION_ADDRESS_VERIFICATION,
  });

  return (
    <AddressCollection
      application={prefillData?.address}
      fetching={prefillDataFetching}
      error={prefillDataError as Error}
      isReapplication={false}
      hasApplicationLoaded={!!reactivationApplicationId}
      isUpdateApplicationSuccess={isUpdateApplicationSuccess}
      isReactivation
      reExecuteQuery={refetchPrefillData}
      updateApplication={updateApplication}
      updateApplicationResult={updateApplicationResult}
      isUpdateApplicationLoading={isUpdateApplicationLoading}
      nextRoute="/reactivation/review-info"
      backRoute="/reactivation/review-info"
    />
  );
};

export default AddressCollectionWrapper;
